import React from 'react';

import CBAINTFileForm from '../Common/Forms/CBAINTFileForm';
import CITIDOMFileForm from '../Common/Forms/CITIDOMFileForm';
import CITIINTFileForm from '../Common/Forms/CITIINTFileForm';
import VCCFileForm from '../Common/Forms/VCCFileForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_ITEM = 'citi-dom-file';

export const items = [
  { title: 'DOMESTIC - CITI ABA', slug: 'citi-dom-file', component: CITIDOMFileForm },
  { title: 'INTERNATIONAL - CBA IPFX', slug: 'cba-int-file', component: CBAINTFileForm },
  { title: 'INTERNATIONAL - CITI WorldLink', slug: 'citi-int-file', component: CITIINTFileForm },
  { title: 'VCC', slug: 'vcc-file', component: VCCFileForm },
];

export default function BankFilesPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEM} />;
}
